var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconNumberFive = function SvgIconNumberFive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M10.15 7.878a.5.5 0 0 1 .494-.428H14.4a.5.5 0 0 1 0 1h-3.323l-.4 2.727c.96-.375 1.913-.425 2.722-.138 1.087.384 1.818 1.345 1.902 2.68.114 1.833-1.16 3.531-3.101 3.531-1.045 0-1.807-.412-2.301-.977-.48-.549-.698-1.228-.699-1.772a.5.5 0 0 1 1-.002c0 .306.133.752.451 1.115.305.348.792.636 1.549.636 1.261 0 2.188-1.102 2.103-2.469-.06-.967-.558-1.56-1.238-1.8-.706-.25-1.702-.15-2.76.496a.5.5 0 0 1-.755-.5z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12 21.25a9 9 0 1 0 0-18 9 9 0 0 0 0 18m0 1c5.523 0 10-4.477 10-10s-4.477-10-10-10-10 4.477-10 10 4.477 10 10 10",
    clipRule: "evenodd"
  })));
};
export default SvgIconNumberFive;